import React from 'react';

const StepBasicDetails = ({
  peopleCount,
  adjust,
  bookingName,
  setBookingName,
  phone,
  setPhone,
  email,
  setEmail,
  theatreName,
  cityName,
  slotLabel,
  showDate,
  maxCapacity = Infinity,
  decorationSelected = false,
  setDecorationSelected,
  decorationPrice = 0,
  decorationAvailable = true,
  couponCode = '',
  setCouponCode,
  onApplyCoupon,
  couponApplying = false,
  couponCanApply = false,
  couponError = '',
  couponSuccess = '',
}) => {
  const canAddPeople = peopleCount + 1 <= maxCapacity;
  const normalizedPhone = String(phone || '').replace(/\D/g, '');
  const isPhoneValid = normalizedPhone.length === 10;
  const emailValue = String(email || '').trim();
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);

  return (
    <>
      <section className="booking-card">
        <h4 className="booking-section-title">Overview</h4>
        <div className="overview-item">
          <i className="bi bi-star-fill overview-icon overview-icon-theatre" />
          {theatreName || 'Selected Theatre'}
        </div>
        <div className="overview-item">
          <i className="bi bi-geo-alt overview-icon overview-icon-location" />
          {cityName || 'City'}
        </div>
        <div className="overview-item">
          <i className="bi bi-calendar4 overview-icon overview-icon-date" />
          {showDate || 'Date'}
        </div>
        <div className="overview-item">
          <i className="bi bi-clock overview-icon overview-icon-time" />
          {slotLabel || 'Time slot'}
        </div>
      </section>

      <section className="booking-card">
        <h4 className="booking-section-title">Booking Details</h4>
        <div className="form-group">
          <label>
            Booking Name <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Type here"
            value={bookingName}
            onChange={(e) => setBookingName(e.target.value)}
          />
          {!bookingName && <div className="error-text">This field is required</div>}
        </div>

        <div className="form-row counters">
          <div className="form-group">
            <label>
              People {Number.isFinite(maxCapacity) && <span className="note">Max {maxCapacity}</span>}
            </label>
            <div className="counter">
              <button type="button" onClick={() => adjust(-1, 1)}>
                -
              </button>
              <span>{peopleCount}</span>
              <button type="button" onClick={() => canAddPeople && adjust(1, 1)} disabled={!canAddPeople}>
                +
              </button>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>
            Whatsapp Number <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Type here"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
            inputMode="numeric"
            maxLength={10}
          />
          {!phone && <div className="error-text">This field is required</div>}
          {phone && !isPhoneValid && <div className="error-text">Enter a valid 10 digit Whatsapp number</div>}
        </div>

        <div className="form-group">
          <label>
            Email ID <span className="required">*</span>
          </label>
          <input
            type="email"
            placeholder="Type here"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {!email && <div className="error-text">This field is required</div>}
          {email && !isEmailValid && <div className="error-text">Enter a valid email address</div>}
        </div>

        <div className="form-group">
          <label>
            Do you want decoration (just {'\u20b9'}{decorationPrice})? *
          </label>
          <select
            value={decorationSelected ? 'Yes' : 'No'}
            onChange={(e) => setDecorationSelected?.(e.target.value === 'Yes')}
            disabled={!decorationAvailable}
          >
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
        </div>

        <div className="form-group coupon-row">
          <label>Coupon code</label>
          <div className="coupon-input">
            <input
              type="text"
              placeholder="Enter coupon"
              value={couponCode}
              onChange={(e) => setCouponCode?.(e.target.value)}
            />
            <button
              type="button"
              className="coupon-apply"
              onClick={onApplyCoupon}
              disabled={!couponCanApply || couponApplying}
            >
              {couponApplying ? 'Applying...' : 'Apply'}
            </button>
          </div>
          {couponError && <div className="error-text">{couponError}</div>}
          {!couponError && couponSuccess && <div className="note">{couponSuccess}</div>}
        </div>
      </section>
    </>
  );
};

export default StepBasicDetails;
